import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";
import { AuthShell } from "@/components/auth/auth-shell";
import { BrandPanel } from "@/components/auth/brand-panel";
import { FormPanel } from "@/components/auth/form-panel";
import { FormPanelHeader } from "@/components/auth/form-panel-header";
import { FormHeading } from "@/components/auth/form-heading";
import ForgotPasswordForm from "@/components/auth/ForgotPasswordForm";
import { isUsernameAuthMode } from "@/lib/config/auth.config";
import Button from "@/components/ui/button/Button";
import Link from "@/lib/next-shims/router-link";

export const Route = createFileRoute("/_auth/forgot-password")({
  component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
  const t = useTranslations();

  return (
    <AuthShell>
      <BrandPanel page="forgot" />
      <FormPanel>
        <FormPanelHeader
          linkOpposite={{
            href: "/signin",
            prompt: "",
            cta: t("auth.forgot.back_to_signin"),
            isBack: true,
          }}
        />
        <FormHeading
          title={isUsernameAuthMode ? t("auth.forgot.disabled_title") : t("auth.forgot.title")}
          description={isUsernameAuthMode ? t("auth.forgot.disabled_desc") : t("auth.forgot.desc")}
        />
        {isUsernameAuthMode ? (
          <Link href="/signin">
            <Button type="button" className="w-full" size="sm">
              {t("auth.forgot.back_to_signin")}
            </Button>
          </Link>
        ) : (
          <ForgotPasswordForm />
        )}
      </FormPanel>
    </AuthShell>
  );
}
